import { z } from 'zod';
import { registry } from './registry';
export const painSchema = z
    .object({
    id: z.string().optional(),
    location: z.string().min(1, 'Location is required').register(registry, { label: 'Location' }),
    level: z
        .string()
        .min(1, 'Pain level is required')
        .register(registry, {
        label: 'Pain Level',
        options: [
            { value: '1', label: '1' },
            { value: '2', label: '2' },
            { value: '3', label: '3' },
            { value: '4', label: '4' },
            { value: '5', label: '5' },
            { value: '6', label: '6' },
            { value: '7', label: '7' },
            { value: '8', label: '8' },
            { value: '9', label: '9' },
            { value: '10', label: '10' },
        ],
    }),
    character: z.string().optional().register(registry, { label: 'Character' }),
    onsetDuration: z.string().optional().register(registry, { label: 'Onset/Duration' }),
    relievingAggravating: z.string().optional().register(registry, { label: 'Relieving/Aggravating' }),
    treatment: z.string().optional().register(registry, { label: 'Treatment' }),
    outcome: z.string().optional().register(registry, { label: 'Outcome' }),
})
    .register(registry, { label: 'Pain Entry' });
